module.exports = __webpack_public_path__ + "static/riskeeper_balloon-b731c7fc7f53d2cdee8a9ed555a57b22.jpg";